import { computed, ref } from "vue";
import { first_connected } from "../../actions/connectToActiveRoom";
import { loadingChatState } from "../chatState";
import { activeRoomState } from "../active_room";
import { existSharingNotThisUser } from "../screenShareState";

// Показывать ли панельку внизу (автоскрытие)
export const _showBar = ref(true);

// Показывать ли панельку внизу (с учетом загрузки)
export function getShowBar() {
  return computed(() => {
    return (
      _showBar.value && first_connected.value && !loadingChatState.startMessages
    );
  });
}

export function getIsScreenShare() {
  return computed(() => {
    return (
      activeRoomState.mode === "stream" &&
      existSharingNotThisUser()
    );
  });
}
